/**
 * Which currency a BI screen uses (CU-869fmhmx8, QA obs. 1), from the options of
 * `/api/master-data/options/currencies?service_type=bi` — Advanced (BI) and its dashboards read the same list:
 *  1. the currency already chosen (a link's `sp`, the dashboard's view) while it is one of the options;
 *  2. else the user's default (`selected`, the server marks it from `default_currency`);
 *  3. else nothing — Advanced (BI) then asks for one. `fallbackToFirst` takes the first option instead: a dashboard
 *     has no currency field, and without a currency the query would mix currencies. Its links carry that currency
 *     to Advanced (BI), which keeps it by rule 1.
 *
 * Returns the option (`{ value, label }`) or `null`. No imports: `node --test` runs it.
 */
export function pickCurrency(options, current = null, { fallbackToFirst = false } = {}) {
	const list = Array.isArray(options) ? options : []
	const same = (a, b) => a !== null && a !== undefined && b !== null && b !== undefined && String(a) === String(b)
	return list.find(o => same(o.value, current))
		|| list.find(o => o.selected)
		|| (fallbackToFirst ? list[0] || null : null)
}
